module.exports = __webpack_public_path__ + "static/media/shopping_fishing_marker.7de371d2.svg";